var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"assets"}},[(!_vm.isAuthenticated)?_c('div',{staticClass:"login-container"},[(!_vm.isAuthenticated)?_c('div',{staticClass:"login-form"},[_c('LoginModal')],1):_vm._e()]):_c('div',[_c('iframe',{attrs:{"src":"https://mgasia.canto.global/v/AssetsLibraryMGP"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }